import { twMerge } from 'tailwind-merge';

import { maskStyle } from 'utils';

interface AccentMaskIconProps {
  src: string;
  className?: string;
}

/**
 * Renders an SVG as a CSS mask filled with the accent gradient, so the icon
 * follows the active accent theme (blue/purple) without any gradient ids in
 * the SVG. The source SVG is used as a stencil only — its own colors are
 * ignored.
 */
export const AccentMaskIcon = ({ src, className }: AccentMaskIconProps) => (
  <span
    aria-hidden
    style={maskStyle(src)}
    className={twMerge(
      'bg-accent-gradient-primary-primary inline-block align-top',
      className
    )}
  />
);
